import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { ObserverFactory } from "@hermes/utils-generic/helpers";

import { AnimateOnScrollDirective } from "./animate-on-scroll.directive";

@NgModule({
    imports: [CommonModule],
    declarations: [AnimateOnScrollDirective],
    exports: [AnimateOnScrollDirective],
    providers: [ObserverFactory],
})
export class AnimateOnScrollDirectiveModule {}
